function __debounce(func, delay) {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

class SlideVideoContainer extends HTMLElement {

    constructor() {
        super();

        // 状态管理
        this.isActive = false;
        this.lastTouchY = 0;
        this.debouncedNavigate = __debounce(this.handleNavigation.bind(this), 300);


        // 创建新容器结构
        const splide = document.createElement('div');
        splide.className = 'splide'
        this.appendChild(splide)
        const track = document.createElement('div');
        track.className = 'splide__track';
        splide.appendChild(track)
        const list = document.createElement('ul');
        list.className = 'splide__list';
        track.appendChild(list)
        this.splideList = list
    }

    connectedCallback() {
        this.initSplide()
        // this.observeActivationState();
        // this.setupEventListeners();
        this.initSwitchBar()
    }

    initSwitchBar () {
        if (!this.dataset.switchBar) return
        const bar = document.getElementById(this.dataset.switchBar)
        Array.from(bar.children).forEach((element, index) => {
            element.addEventListener('click', () => {
                this.splide.go(index)
            })
        })

    }

    initSplide() {
        const slides = [...this.children].filter(el =>
            el.tagName === 'SLIDE-VIDEO'
        );

        slides.forEach(slide => {
            const li = document.createElement('li');
            li.className = 'splide__slide';
            li.appendChild(slide); // 移动原元素而非克隆
            this.splideList.appendChild(li);
        });

        const splide = new Splide( this.querySelector('.splide'), {
            arrows: false,
            gap: 20,
            perPage: 1,
            mediaQuery: 'min',
            breakpoints: {
                0: {
                    padding: { right: 40 }
                },
                750: {
                    padding: { right: 130 }
                }
            }
        }).mount();

        splide.on('active', (e) => {
            const slideVideo = e.slide.querySelector('slide-video')
            slideVideo.play()
        })

        this.splide = splide
    }

    /* =================== 滚动网页切换视频 START ======================*/

    observeActivationState() {
        // 精确的视口观察器
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.intersectionRatio === 1) {
                    // 完全进入视野，激活滚动切换功能
                    if (!this.isActive) {
                        this.activateContainer()
                    }
                } else if (entry.intersectionRatio === 0) {
                    // 完全离开视野，关闭滚动切换功能
                    if (this.isActive) {
                        this.deactivateContainer()
                    }
                }
            });
        }, {
            threshold: [0, 1]
        });

        observer.observe(this);
    }
    activateContainer() {
        this.isActive = true;
        this.querySelector('slide-video')?.play()
    }
    deactivateContainer() {
        this.isActive = false;
        this.releaseScroll();
    }
    setupEventListeners() {
        // 桌面端事件
        document.addEventListener('wheel', this.handleScroll.bind(this), { passive: false });

        // 移动端事件
        document.addEventListener('touchstart', e => {
            this.lastTouchY = e.touches[0].clientY;
        }, { passive: true });

        document.addEventListener('touchend', this.handleTouchEnd.bind(this));

        // 键盘事件
        document.addEventListener('keydown', this.handleKeys.bind(this));
    }
    // 防抖处理的滚动事件
    handleScroll(e) {
        if (!this.isActive) return;

        e.preventDefault();
        e.stopPropagation();
        const delta = Math.sign(e.deltaY);
        this.debouncedNavigate(delta);
    }
    // 触摸结束事件处理
    handleTouchEnd(e) {
        if (!this.isActive) return;

        const deltaY = this.lastTouchY - e.changedTouches[0].clientY;
        if (Math.abs(deltaY) > 10) {
            const direction = Math.sign(deltaY) * -1;
            this.debouncedNavigate(direction);
        }
    }
    // 键盘事件处理
    handleKeys(e) {
        if (!this.isActive) return;

        if ([38, 40].includes(e.keyCode)) {
            e.preventDefault();
            this.debouncedNavigate(e.keyCode === 40 ? 1 : -1);
        }
    }
    // 最终的导航处理
    handleNavigation(direction) {
        const currentIndex = this.splide.index;
        const lastIndex = this.splide.length - 1;
        if (direction > 0 && currentIndex < lastIndex) {
            this.splide.go('>');
        } else if (direction < 0 && currentIndex > 0) {
            this.splide.go('<');
        } else {
            this.deactivateContainer()
        }
    }
    releaseScroll() {
        this.style.scrollSnapStop = 'normal';
        // 触发一次微小的滚动让浏览器接管
        setTimeout(() => {
            window.scrollBy({
                top: 1,
                behavior: 'smooth'
            });
        }, 100);
    }
    disconnectedCallback() {
    }


    /* =================== 滚动网页切换视频 END ======================*/
}
customElements.define('slide-video-container', SlideVideoContainer);

class SlideVideo extends HTMLElement {
    constructor() {
    super();
    this.innerHTML = `
        <div class="slide-video">
            <div class="slide-video-loader"><span></span></div>
            <div class="slide-video-container">
                <video muted playsinline loop class="hidden">
                  <source data-src="" type="video/mp4">
                </video>
                <img class="poster image-loading" data-src="">
            </div>
        </div>
        `;
        // 延迟加载阈值配置
        this.INTERSECTION_THRESHOLD = 0.1;
        this.VIDEO_LOAD_THRESHOLD = 0.8;
        this.observerOptions = {
            root: null,
            rootMargin: '500px 0px', // 预加载距离
            threshold: [this.INTERSECTION_THRESHOLD, this.VIDEO_LOAD_THRESHOLD]
        };
        this.observer = null;
        this.isVideoLoaded = false;
        this.isImageLoaded = false


        this.container = this.querySelector('.slide-video-container')
        this.slideVideo = this.querySelector('.slide-video')
        this.video = this.querySelector('video')
        this.source = this.querySelector('video source')
        this.poster = this.querySelector('.poster')
        this.videoLoading = this.querySelector('.slide-video-loader')

        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        let videoUrl, videoPoster
        if (isMobile) {
            videoUrl = this.getAttribute('mobile-video')
            videoPoster = this.getAttribute('mobile-poster')
            if (this.dataset.mobileVideoRatio) {
              this.container.style.setProperty('aspect-ratio', this.dataset.mobileVideoRatio)
            }
        } else {
            videoUrl = this.getAttribute('desktop-video')
            videoPoster = this.getAttribute('desktop-poster')
          if (this.dataset.desktopVideoRatio) {
            this.container.style.setProperty('aspect-ratio', this.dataset.desktopVideoRatio)
          }
        }
        this.source.src = videoUrl
        this.poster.dataset.src = videoPoster;


        if (this.dataset.title) {
            const titleWrapper = document.createElement('div')
            titleWrapper.className = 'title-wrapper'
            const title = document.createElement('h2')
            title.innerText = this.dataset.title
            title.className = 'h5 font-heading-bold'
            titleWrapper.appendChild(title)
            this.slideVideo.appendChild(titleWrapper)

        }
    }
    connectedCallback() {
        this.initIntersectionObserver();
        this.setupEventListeners();
    }
    disconnectedCallback() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
    closeObserver() {
      if (this.isVideoLoaded && this.isImageLoaded) {
        this.observer.disconnect();
      }
    }
    initIntersectionObserver() {
        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                // 处理图片懒加载
                if (entry.intersectionRatio >= this.INTERSECTION_THRESHOLD) {
                    this.loadImages();
                }
                if (entry.intersectionRatio >= this.VIDEO_LOAD_THRESHOLD) {
                  this.play()
                }
            });
            this.closeObserver()
        }, this.observerOptions);
        this.observer.observe(this);
    }
    loadImages() {
        this.querySelectorAll('[data-src]').forEach(el => {
            if (el.tagName === 'IMG' && !el.src) {
                // 添加渐进加载效果
                const tempImg = new Image();
                tempImg.src = el.dataset.src;
                tempImg.onload = () => {
                    el.src = el.dataset.src;
                    el.classList.remove('loading');
                    this.isImageLoaded = true
                };
            }
        });
    }

    setupEventListeners() {
        // 封面图点击处理
        const handlePosterClick = () => {
            this.play()
        };
        this.poster.addEventListener('click', handlePosterClick);
    }
    loadVideo() {
        return new Promise((resolve, reject) => {
            // 如果视频元数据已经存在但需要重新加载
            if (this.source.src) {
                this.video.load();
            }
            // 事件监听器（成功）
            const successHandler = () => {
                cleanup();
                resolve();
            };
            // 事件监听器（失败）
            const errorHandler = () => {
                cleanup();
                reject(new Error('视频加载失败'));
            };
            // 清理事件监听器
            const cleanup = () => {
                this.video.removeEventListener('loadeddata', successHandler);
                this.video.removeEventListener('error', errorHandler);
            };
            // 添加临时事件监听
            this.video.addEventListener('loadeddata', successHandler);
            this.video.addEventListener('error', errorHandler);
            // 如果是首次加载需要设置视频源
            if (!this.source.src) {
                reject(new Error('未设置视频源'));
                // 这里应该添加设置视频源的逻辑
                // 例如：this.video.src = 'your-video-source.mp4';
            }
        });
    }

    async play() {
        if (this.videoLoading.style.display === 'block') {
            return
        }
        try {
            if (!this.isVideoLoaded) {
                this.videoLoading.style.display = 'block'
                await this.loadVideo();
                this.isVideoLoaded = true
            }

            this.poster.classList.add('hidden')
            this.video.classList.remove('hidden')
            await this.video.play();
        } catch (error) {
            console.error('播放失败:', error.message);
            // 这里可以添加错误处理逻辑
        } finally {
            this.videoLoading.style.display = 'none'
        }
    }

    pause() {
        this.video.pause();
    }
}
customElements.define('slide-video', SlideVideo);
